import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from '../ui/colors';

const StyledIcon = styled(({width, height, fill, stroke, strokeWidth, children, ...rest}) => {
	return <svg {...rest}>{children}</svg>;
})`
  display: inline-block;
  vertical-align: middle;

  ${props => props.width && (`
    width: ${props.width};
  `)}
  ${props => props.height && (`
    height: ${props.height};
  `)}
  ${props => props.fill && (`
     fill: ${props.fill};
  `)}
  ${props => props.stroke && (`
     stroke: ${props.stroke};
  `)}
  ${props => props.strokeWidth && (`
     stroke-width: ${props.strokeWidth};
  `)}
`;

StyledIcon.defaultProps = {
	fill        : colors.WHITE,
	stroke      : 'none',
	strokeWidth : '2px'
};


const propTypes = {
	icon        : PropTypes.string.isRequired,
	color       : PropTypes.string,
	width       : PropTypes.string,
	height      : PropTypes.string,
	fill        : PropTypes.string,
	stroke      : PropTypes.string,
	strokeWidth : PropTypes.string,
	className   : PropTypes.string,
};

const defaultProps = {
	color  : colors.WHITE,
	width  : '23px',
	height : '23px',
	stroke : 'none',
	fill   : colors.WHITE,
};

const Icon = (props) => {
	return (
		<StyledIcon className={props.className}
								width={props.width}
								height={props.height}
								fill={props.fill}
								stroke={props.stroke}
								strokeWidth={props.strokeWidth}
								xmlns="http://www.w3.org/2000/svg"
								version="1.1">
			<use xlinkHref={`${props.icon}`}/>
		</StyledIcon>
	);
};

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default Icon;


// WEBPACK FOOTER //
// ./src/icons/Icon.js